import { render, staticRenderFns } from "./StatsPathCard.vue?vue&type=template&id=495fa7d0&scoped=true"
import script from "./StatsPathCard.vue?vue&type=script&lang=js"
export * from "./StatsPathCard.vue?vue&type=script&lang=js"
import style0 from "./StatsPathCard.vue?vue&type=style&index=0&id=495fa7d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fa7d0",
  null
  
)

export default component.exports